// Powers the mobile-only (<768px) horizontal Blogs carousel on the homepage
// (sections/blog-carousel.liquid). The track is a native horizontally
// scrollable flex container (overflow-x-auto + scroll-snap), so touch
// swipe/drag already moves it with zero JS. At the `md` breakpoint the track
// becomes `display:contents` and the section reverts to its original plain
// 3-column grid (untouched) - this script becomes an intentional no-op there
// (canAutoplay() checks isMobileViewport()). Mirrors assets/hero-slider.js's
// proven index/goTo/autoplay/pause-on-interaction pattern. RTL/LTR arrow
// direction is handled purely via CSS (`rtl:rotate-180` + logical
// start/end positioning in the Liquid markup) - no RTL branching needed here,
// same convention as the rest of the theme.
(function () {
  var SPEED = 4500; // gentle/subtle autoplay interval, slower than the hero slider

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function initCarousel(root) {
    if (root.dataset.blogCarouselInitialized === 'true') return;

    var track = root.querySelector('[data-blog-carousel-track]');
    var prevBtn = root.querySelector('[data-blog-carousel-prev]');
    var nextBtn = root.querySelector('[data-blog-carousel-next]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    root.dataset.blogCarouselInitialized = 'true';

    var current = 0;
    var timer = null;
    var interacting = false;
    var syncingFromScroll = false;

    function goTo(index, behavior) {
      current = (index + slides.length) % slides.length;
      syncingFromScroll = true;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: behavior || 'smooth' });
      window.setTimeout(function () { syncingFromScroll = false; }, 500);
    }

    function canAutoplay() {
      return isMobileViewport()
        && !prefersReducedMotion()
        && !document.hidden
        && !interacting;
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!canAutoplay()) return;
      timer = setInterval(function () {
        if (!canAutoplay()) return;
        goTo(current + 1);
      }, SPEED);
    }

    function resetTimer() {
      stopTimer();
      startTimer();
    }

    function manualGoTo(index) {
      goTo(index);
      resetTimer();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { manualGoTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { manualGoTo(current + 1); });
    }

    // Keeps `current` in sync with any scroll source (native touch swipe,
    // trackpad) - not just arrow clicks - by finding the slide nearest the
    // current scroll position.
    var scrollDebounce;
    track.addEventListener('scroll', function () {
      if (syncingFromScroll) return;
      window.clearTimeout(scrollDebounce);
      scrollDebounce = window.setTimeout(function () {
        var nearest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (dist < closestDist) {
            closestDist = dist;
            nearest = i;
          }
        });
        current = nearest;
        resetTimer();
      }, 120);
    }, { passive: true });

    // Pause autoplay while the user is touching/dragging/pressing the
    // track, resume once released - required by spec.
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        interacting = true;
        stopTimer();
      }, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'mouseleave'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        interacting = false;
        resetTimer();
      }, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else {
        resetTimer();
      }
    });

    // Starts/stops autoplay as the viewport crosses the 768px breakpoint
    // (orientation change, browser resize) since the track becomes
    // `display:contents` (non-scrollable) at `md` and back.
    var resizeDebounce;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeDebounce);
      resizeDebounce = window.setTimeout(resetTimer, 150);
    });

    var reducedMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotionQuery && reducedMotionQuery.addEventListener) {
      reducedMotionQuery.addEventListener('change', resetTimer);
    }

    startTimer();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-blog-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  if (document.readyState !== 'loading') {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
